/** Axios / fetch-style errors with no HTTP response body. */
export function isNetworkError(error) {
  if (!error) return false;
  if (error.response != null) return false;
  const code = error.code;
  if (code === "ERR_NETWORK" || code === "ECONNABORTED") return true;
  const msg = typeof error.message === "string" ? error.message : "";
  if (/network error/i.test(msg)) return true;
  if (
    error instanceof TypeError &&
    /fetch|load failed|failed to fetch|networkerror/i.test(msg)
  ) {
    return true;
  }
  return false;
}
